import { render, staticRenderFns } from "./Form.vue?vue&type=template&id=33279fdd"
import script from "./Form.vue?vue&type=script&lang=js"
export * from "./Form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/github/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('33279fdd')) {
      api.createRecord('33279fdd', component.options)
    } else {
      api.reload('33279fdd', component.options)
    }
    module.hot.accept("./Form.vue?vue&type=template&id=33279fdd", function () {
      api.rerender('33279fdd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/signin/Form.vue"
export default component.exports